import { faChartLine, faTable } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import './index.scss';

interface ViewTogglerProps {
  showGraph: boolean,
  showTable: boolean,
  toggleGraph: () => void,
  toggleTable: () => void,
}

export default function ViewToggler({
  showGraph, showTable, toggleGraph, toggleTable,
}: ViewTogglerProps) {
  return (
    <div className="d-flex view-toggler">
      <Button
        className={`me-2 btn ${showGraph ? 'active' : ''}`}
        onClick={toggleGraph}
      >
        <FontAwesomeIcon
          icon={faChartLine}
          fontSize="25px"
        />
      </Button>
      <Button
        className={`btn btn-primary ${showTable ? 'active' : ''}`}
        onClick={toggleTable}
      >
        <FontAwesomeIcon
          icon={faTable}
          fontSize="25px"
        />
      </Button>
    </div>
  );
}
